import { useState } from 'react';
import { FaHandshake, FaHeadphones, FaLightbulb, FaCode, FaRocket, FaChartLine, FaArrowRight } from 'react-icons/fa';
import styles from './WorkflowSection.module.css';

const WorkflowSection = () => {
  const [activeStep, setActiveStep] = useState(null);

  const workflowSteps = [
    {
      icon: <FaHandshake />,
      title: "Primer Contacto",
      description: "Establecemos una conexión inicial para entender tu visión y objetivos.",
      details: "Nos reunimos contigo para conocer a fondo tu negocio, tus metas y expectativas. Esta fase es crucial para establecer una relación de confianza y entender completamente tu proyecto.",
      step: "01"
    },
    {
      icon: <FaHeadphones />,
      title: "Escuchamos Necesidades",
      description: "Analizamos detalladamente tus requerimientos y expectativas.",
      details: "Realizamos un análisis profundo de tus necesidades, investigamos tu mercado y competencia, y definimos los objetivos específicos que tu proyecto digital debe cumplir.",
      step: "02"
    },
    {
      icon: <FaLightbulb />,
      title: "Proponemos Solución",
      description: "Diseñamos una estrategia personalizada para tu proyecto.",
      details: "Creamos un plan estratégico y presentamos una propuesta detallada que incluye diseño, funcionalidades, tecnologías a utilizar, plazos y presupuesto.",
      step: "03"
    },
    {
      icon: <FaCode />,
      title: "Desarrollo",
      description: "Implementamos la solución con las mejores prácticas y tecnologías.",
      details: "Nuestro equipo de desarrolladores trabaja en la creación de tu proyecto utilizando las tecnologías más adecuadas y siguiendo metodologías ágiles para garantizar calidad y eficiencia.",
      step: "04"
    },
    {
      icon: <FaRocket />,
      title: "Implementación",
      description: "Desplegamos tu solución y aseguramos su correcto funcionamiento.",
      details: "Lanzamos tu proyecto al mundo, realizamos pruebas exhaustivas y nos aseguramos de que todo funcione perfectamente en todos los dispositivos y navegadores.",
      step: "05"
    },
    {
      icon: <FaChartLine />,
      title: "Monitoreo",
      description: "Seguimiento continuo y optimización del rendimiento.",
      details: "Proporcionamos soporte continuo, analizamos el rendimiento de tu proyecto y realizamos mejoras constantes para mantenerlo actualizado y optimizado.",
      step: "06"
    }
  ];

  const handleStepClick = (index) => {
    setActiveStep(activeStep === index ? null : index);
  };

  return (
    <section className={styles.workflowSection}>
      <div className={styles.workflowContainer}>
        <div className={styles.sectionHeader}>
          <div className={styles.badge}>
            <span>Metodología</span>
          </div>
          <h2>Nuestro Proceso</h2>
          <p>Un enfoque estructurado y transparente para garantizar el éxito de tu proyecto</p>
        </div>
        
        <div className={styles.workflowGrid}>
          {workflowSteps.map((step, index) => (
            <div 
              key={index} 
              className={`${styles.workflowCard} ${activeStep === index ? styles.active : ''}`}
              onClick={() => handleStepClick(index)}
            >
              <div className={styles.cardContent}>
                <div className={styles.stepNumber}>{step.step}</div>
                <div className={styles.iconContainer}>
                  {step.icon}
                </div>
                <h3 className={styles.stepTitle}>{step.title}</h3>
                <p className={styles.stepDescription}>{step.description}</p>
                
                <div className={styles.expandedContent}>
                  <p>{step.details}</p>
                  <div className={styles.nextStep}>
                    {index < workflowSteps.length - 1 && (
                      <div className={styles.nextStepInfo}>
                        <span>Siguiente paso:</span>
                        <p>{workflowSteps[index + 1].title}</p>
                        <FaArrowRight className={styles.nextIcon} />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              
              {index < workflowSteps.length - 1 && index % 3 !== 2 && (
                <div className={styles.connector}>
                  <div className={styles.connectorLine}></div>
                  <div className={styles.connectorArrow}></div>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className={styles.workflowCta}>
          <p>¿Listo para comenzar tu proyecto?</p>
          <a href="/presupuesto" className={styles.ctaButton}>
            Solicitar Presupuesto
          </a>
        </div>
      </div>
    </section>
  );
};

export default WorkflowSection;